module.exports = __webpack_public_path__ + "img/sm.52725385.png";